import { render, staticRenderFns } from "./ManualNewLomCreate.vue?vue&type=template&id=6665f024&scoped=true"
import script from "./ManualNewLomCreate.vue?vue&type=script&lang=js"
export * from "./ManualNewLomCreate.vue?vue&type=script&lang=js"
import style0 from "./ManualNewLomCreate.vue?vue&type=style&index=0&id=6665f024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665f024",
  null
  
)

export default component.exports